var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardsBigActive24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3B2CC6EB-642F-4AE7-BFDD-D39574CF8DB1_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-1176.000000, -101.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(566.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(610.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Cards-Big_Active-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,13 L21.4361148,13 C22.3276335,13 22.6509198,13.0928256 22.9768457,13.2671327 C23.3027716,13.4414398 23.5585602,13.6972284 23.7328673,14.0231543 C23.9071744,14.3490802 24,14.6723665 24,15.5638852 L24,20.4361148 C24,21.3276335 23.9071744,21.6509198 23.7328673,21.9768457 C23.5585602,22.3027716 23.3027716,22.5585602 22.9768457,22.7328673 C22.6509198,22.9071744 22.3276335,23 21.4361148,23 L2.5638852,23 C1.67236646,23 1.34908022,22.9071744 1.0231543,22.7328673 C0.697228371,22.5585602 0.441439796,22.3027716 0.267132704,21.9768457 C0.0928256111,21.6509198 4.01235366e-17,21.3276335 -6.90560205e-17,20.4361148 L6.90560205e-17,15.5638852 C-4.01235366e-17,14.6723665 0.0928256111,14.3490802 0.267132704,14.0231543 C0.441439796,13.6972284 0.697228371,13.4414398 1.0231543,13.2671327 C1.34908022,13.0928256 1.67236646,13 2.5638852,13 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,-1.03584031e-16 L21.4361148,1.03584031e-16 C22.3276335,-6.01853049e-17 22.6509198,0.0928256111 22.9768457,0.267132704 C23.3027716,0.441439796 23.5585602,0.697228371 23.7328673,1.0231543 C23.9071744,1.34908022 24,1.67236646 24,2.5638852 L24,7.4361148 C24,8.32763354 23.9071744,8.65091978 23.7328673,8.9768457 C23.5585602,9.30277163 23.3027716,9.5585602 22.9768457,9.7328673 C22.6509198,9.90717439 22.3276335,10 21.4361148,10 L2.5638852,10 C1.67236646,10 1.34908022,9.90717439 1.0231543,9.7328673 C0.697228371,9.5585602 0.441439796,9.30277163 0.267132704,8.9768457 C0.0928256111,8.65091978 4.01235366e-17,8.32763354 -6.90560205e-17,7.4361148 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 Z",
    id: "Rectangle-Copy-2"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardsBigActive24Px);
export default __webpack_public_path__ + "static/media/Icon_Cards-Big_Active-24px.e17ee0a4cb216944d9924719a3dfef1b.svg";
export { ForwardRef as ReactComponent };